var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fun_wrapper"},[_c('h4',[_vm._v("产品功能")]),_c('div',{staticClass:"content"},[_c('el-image',{staticStyle:{"width":"100%","height":"1000px"},attrs:{"src":require('../assets/imgs/fun.png'),"fit":'fit'}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }